export default __webpack_public_path__ + "static/media/cloudy.b1531aae.svg";